/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} Render_Audio_Rendering_StatusInputs */



/**
* | output |
* | --- |
* | "Rendering event {start}-{end} of {total}" |
*
* @param {Render_Audio_Rendering_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_rendering_status = /** @type {((inputs: Render_Audio_Rendering_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Rendering_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Rendu de l'evenement ${i?.start}-${i?.end} sur ${i?.total}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Rendering-Ereignis ${i?.start}-${i?.end} von ${i?.total}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Evento di rendering ${i?.start}-${i?.end} di ${i?.total}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие рендеринга ${i?.start}-${i?.end} события ${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Evento de representación ${i?.start}-${i?.end} de ${i?.total}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`渲染事件 ${i?.start}-${i?.end} 的 ${i?.total}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`レンダリングイベント ${i?.start}-${i?.end} / ${i?.total}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.total} के ${i?.start}-${i?.end} इवेंट को रेंडर किया जा रहा है`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Renderizando evento ${i?.start}-${i?.end} de ${i?.total}`)
	return /** @type {LocalizedString} */ (`Rendering event ${i?.start}-${i?.end} of ${i?.total}`)
});